<template>
  <div class="">
    <div class="head-title">文案库</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            企业根据实际进行产品详情、企业动态等文案的发布，成员可自由选择文案并在名片中展示。
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <div class="navbar">
        <div class="nav-l">
          <el-button @click="add" icon="el-icon-plus" type="primary"
            >添加文案</el-button
          >
        </div>
        <div class="nav-r">
          <div>
            <el-date-picker
            style="width:50.0rem"
              v-model="time"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :picker-options="pickerOptions"
              @change="haha"
            >
            </el-date-picker>
          </div>
          <div style="margin-left: 2.4rem">
            <el-input
              v-model="q"
              clearable
              style="width: 35.0rem;"
              prefix-icon="el-icon-search"
              placeholder="请输入文案标题搜索"
              @change="haha"
            >
            <el-button type="primary" slot="append" @click="haha"
              >查询</el-button
            >
            </el-input>

          </div>
        </div>
      </div>
      <div class="">
        <el-table
          :data="tableData"
          border
          v-loading="tableLoading"
          style="margin-top: 2.0rem"
        >
          <el-table-column
            prop="title"
            label="文案标题"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="cover" label="文案封面">
            <template slot-scope="scope">
              <el-image
                style="width: 9.6rem; height: 4.0rem"
                :src="scope.row.cover"
                :preview-src-list="[scope.row.cover]"
                fit="scale-down"
              >
                <div slot="error" class="image-slot">暂无封面</div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="createtime" label="创建时间"></el-table-column>

          <!-- <el-table-column prop="state" label="发布状态" width="120">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.state"
                :active-value="2"
                :inactive-value="1"
                @change="toggleStatus(scope.row.state, scope.row.id)"
              ></el-switch>
            </template>
          </el-table-column> -->
          <el-table-column label="操作" fixed="right" width="300">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="
                  (dialogVisible = true),
                    modify(
                      scope.row.id,
                      scope.row.title,
                      scope.row.content,
                      scope.row.scope,
                      scope.row.originContent,
                      scope.row.cover
                    )
                "
                type="text"
                >编辑</el-button
              >
              <el-button
                @click="handleClick(scope.row)"
                type="text"
                size="small"
              ></el-button>
              <el-button style="color:#f00000 !important;" size="mini" @click="dele(scope.row.id)" type="text"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div>
          <pagination
            :total="total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            :page-sizes="[10,20,50,100]"
            :auto-scroll="false"
            @pagination="haha"
          />
        </div>
        <el-dialog
          center
          title="修改文案"
          :visible.sync="dialogVisible"

          width="80%"
          lock-scroll
          append-to-body
        >
          <el-form ref="form" :model="form" label-width="10.0rem">
            <el-form-item label="文案标题：">
              <el-input clearable v-model="form.title">{{
                form.title
              }}</el-input>
            </el-form-item>
            <el-form-item label="文案封面：">
              <el-upload
                class="upload-demo"
                :action="`${baseURL}/api/Alioss/uploadTotal`"
                :on-preview="handlePreviewEdit"
                :on-remove="handleRemoveEdit"
                :before-remove="beforeRemoveEdit"
                accept=".png,.jpg"
                :on-exceed="handleExceedEdit"
                :on-success="handleSuccessEdit"
                :file-list="fileListEdit"
                list-type="picture"
                :limit="1"
              >
                <el-button type="primary">上传图片</el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过500kb，图片尺寸请保证在350*210像素
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="文案内容：">
              <div style="overflow: hidden">
                <vue-ueditor-wrap
                  v-model="mani"
                  :config="myConfig"
                ></vue-ueditor-wrap>
              </div>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="vak()">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog
          center
          title="添加文案"
          :visible.sync="onSubmit"

          width="80%"
          lock-scroll
          append-to-body
        >
          <el-form ref="form" :model="form" label-width="10.0rem">
            <el-form-item label="文案标题：">
              <el-input clearable v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="文案封面：">
              <el-upload
                class="upload-demo"
                :action="`${baseURL}/api/Alioss/uploadTotal`"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                accept=".png,.jpeg,.jpg"
                :on-exceed="handleExceed"
                :on-success="handleSuccess"
                :file-list="fileListAdd"
                list-type="picture"
                :limit="1"
              >
                <el-button type="primary">上传图片</el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过500kb，图片尺寸请保证在350*210像素
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="文案内容：">
              <div style="overflow: hidden">
                <vue-ueditor-wrap
                  v-model="value"
                  :config="myConfig"
                ></vue-ueditor-wrap>
              </div>
            </el-form-item>
          </el-form>

          <span slot="footer" class="dialog-footer">
            <el-button @click="onSubmit = false">取 消</el-button>
            <el-button type="primary" @click="numoo()">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  data() {
    return {
      tableData: [],
      formInline: {
        user: "",
      },
      dialogVisible: false,
      form: {
        name: "",
        title: "",
      },
      fabule: {
        a: "未发布",
        b: "已发布",
      },
      onSubmit: false,
      modifys: "", //修改点击来接收的id,
      dengj: "",
      fabufanw: "",
      mani: "", //价格
      tooken: "",
      title: {},
      value: "填写文案",
      myConfig: {
        // 编辑器不自动被内容撑高
        // autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 340,
        // 初始容器宽度
        initialFrameWidth: "100%",
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: "https://api.weijub.com/upload/controller.php",
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: "/UEditor/",
        zIndex: 2003,
      },
      valueee: "",
      valuee: "",
      value1: true,
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      loading: true,
      baseURL: this.axios.defaults.baseURL,
      fileListEdit: [],
      fileListAdd: [],
      q: "",
      time: [],
      pickerOptions: {
        disabledDate: (date) => {
          const time = date.getTime();
          return (
            time > Date.now() - 3600 * 1000 * 24 * 1 &&
            time > Date.now() - 3600 * 1000 * 24 * 30
          );
        },
        shortcuts: [
          {
            text: "最近一天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime());
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(end.getTime());
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              end.setTime(end.getTime());
              picker.$emit("pick", [start, end]);
            },
          },
        ],
        tableLoading: true,
      },
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.haha();
  },
  components: {
    VueUeditorWrap,
    Pagination,
  },
  methods: {
    haha() {
      let start_time = "";
      let end_time = "";
      if (this.time !== null && this.time.length) {
        start_time = parseInt(this.time[0].getTime() / 1000);
        end_time = parseInt(this.time[1].getTime() / 1000);
      }
      this.axios
        .post(
          "/crm/UserCardContent/list",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
            title: this.q,
            start_time,
            end_time,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          console.log(res);
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          res.data.data.data.forEach((i) => {
            i.originContent = i.content;
            if (i.content.length > 120) {
              i.content = i.content.slice(0, 140) + "...";
            }
          });
          this.tableLoading = false;
          this.total = res.data.data.total;
          this.tableData = res.data.data.data;
        })
        .catch(function (err) {});
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    //  通过点击事件触发监听事件rowbundleRenderer
    modify(e, l, el, ol, originContent, cover) {
      this.fabufanw = ol;
      this.modifys = e;
      this.mani = originContent;
      this.form.title = l;
      this.fileListEdit = [
        {
          name: "文案封面",
          response: {
            data: {
              url: cover,
            },
          },
          url: cover,
        },
      ];
    },
    vak() {
      if (!this.form.title) {
        this.$message.error("您还没有填写标题");
        return;
      }
      if (!this.fileListEdit.length) {
        this.$message.error("您还没有上传封面");
        return;
      }

      this.axios
        .post(
          "/crm/UserCardContent/edit",
          qs.stringify({
            content: this.mani,
            id: this.modifys,
            title: this.form.title,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            cover: this.fileListEdit[0].response.data.url,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          if (res.data.code == 1) {
            this.dialogVisible = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.dialogVisible = true;
            this.$message.error(res.data.msg);
          }
          this.haha();
        })
        .catch(function (err) {});
    },
    toggleStatus(e, l) {
      this.axios
        .post(
          "/crm/UserCardContent/edit",
          qs.stringify({
            id: l,
            state: e,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.haha();
          // this.tableData[length].levelName=this.dengj
          // window.location.replace("http://localhost:8080/about/grade");
        })
        .catch(function (err) {});
    },
    handleClick(row) {},
    // 删除代理等级管理
    dele(e) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/UserCardContent/del",
              qs.stringify({
                id: e,
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.haha();

              this.$message({
                message: res.data.msg,
                type: res.data.code == 1 ? "success" : "error",
              });
            })
            .catch(function (err) {});
        })
        .catch(() => {
          this.$message({
            message: "已取消删除",
            type: "info",
          });
        });
    },
    // 添加
    numoo() {
      if (!this.form.name) {
        this.$message.error("您还没有填写标题");
        return;
      }
      if (!this.fileListAdd.length) {
        this.$message.error("您还没有上传封面");
        return;
      }
      this.axios
        .post(
          "/crm/UserCardContent/add",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            title: this.form.name,
            content: this.value,
            cover: this.fileListAdd[0].response.data.url,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.fileListAdd = [];
            this.form.name=""
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }

          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.haha();
        })
        .catch(function (err) {});
    },
    handleSuccess(response, file, fileList) {
      this.fileListAdd = fileList;
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file, fileList) {},
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`, {
        type: "warning",
      });
    },
    handleSuccessEdit(response, file, fileList) {
      this.fileListEdit = fileList;
    },
    handlePreviewEdit(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemoveEdit(file, fileList) {},
    handleExceedEdit(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemoveEdit(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`, {
        type: "warning",
      });
    },
    add() {
      this.onSubmit = true;
      this.value = "";
    },
  },
};
</script>

<style>
/* 修改element_ui弹出层比编辑器层级高，导致编辑器添加附件弹窗显示在element_ui弹出层后的问题 */
/* .el-dialog__wrapper{
  z-index: 2020!important;
}
.edui-default {
  z-index: 2021 !important;
} */
</style>
<style lang="scss" scoped>
::v-deep .el-dialog__wrapper {
  z-index: 1000 !important;
}
::v-deep .edui-default {
  z-index: 9999 !important;
}
::v-deep .el-upload-list--picture .el-upload-list__item-thumbnail {
  width: 15.5rem;
  height: 6.5rem;
}
.home {
  height: 100%;
  width: 100%;
}
.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia > main {
  font-size: 2.6rem;
}
.bule {
  width: 100%;
  height: 6.9rem;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}
.ovued {
  margin: 0 auto;
  width: 7.0rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.aaas {
  color: blue;
}
.nav-r {
  display: flex;
}
.el-button--text{padding-left:.0rem !important;}

</style>

